/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AssignStationToPartnerOperator$Params {

/**
 * Country code of the partner operator credentials role
 */
  countryCode: string;

/**
 * Party id of the partner operator credentials role
 */
  partyId: string;

/**
 * Uid of the station
 */
  stationUid: string;
}

export function assignStationToPartnerOperator(http: HttpClient, rootUrl: string, params: AssignStationToPartnerOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, assignStationToPartnerOperator.PATH, 'post');
  if (params) {
    rb.path('countryCode', params.countryCode, {});
    rb.path('partyId', params.partyId, {});
    rb.path('stationUid', params.stationUid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

assignStationToPartnerOperator.PATH = '/partners/operator/{countryCode}/{partyId}/station/{stationUid}/assign';
